import axios from 'axios';
import * as CryptoJS from 'crypto-js';

const baseURL = `${process.env.REACT_APP_API_URL}/accounts/index.php`;
let CryptoJSAesJson = {
    /**
     * Encrypt any value
     * @param {*} value
     * @param {string} password
     * @return {string}
     */
    'encrypt': function (value, password) {
        return CryptoJS.AES.encrypt(JSON.stringify(value), password, { format: CryptoJSAesJson }).toString()
    },
    /**
     * Decrypt a previously encrypted value
     * @param {string} jsonStr
     * @param {string} password
     * @return {*}
     */
    'decrypt': function (jsonStr, password) {
        return JSON.parse(CryptoJS.AES.decrypt(jsonStr, password, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8))
    },
    /**
     * Stringify cryptojs data
     * @param {Object} cipherParams
     * @return {string}
     */
    'stringify': function (cipherParams) {
        var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) }
        if (cipherParams.iv) j.iv = cipherParams.iv.toString()
        if (cipherParams.salt) j.s = cipherParams.salt.toString()
        return JSON.stringify(j).replace(/\s/g, '')
    },
    /**
     * Parse cryptojs data
     * @param {string} jsonStr
     * @return {*}
     */
    'parse': function (jsonStr) {
        var j = JSON.parse(jsonStr)
        var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
        if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
        if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
        return cipherParams
    }
}

export const accountService = {
    signUp1,
    signUp2,
    resendOTP,
    verifySignUpOTP
};

async function signUp1(userData) {
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(userData, password);

    return await axios.post(`${baseURL}?type=1`, encrypted)
                    .then(response => response.data)
                    .catch(err => {console.log(err);});
}

async function signUp2(userData, userID) {
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted1 = CryptoJSAesJson.encrypt(userID, password);
    let encrypted2 = CryptoJSAesJson.encrypt(userData, password);
    // console.log(encrypted);
    return await axios.post(`${baseURL}?type=2&data=${encrypted1}`, encrypted2)
                    .then(response => response.data)
                    .catch(err => {console.log(err);});
}

async function verifySignUpOTP(userID, pin) {
    var valueToEncrypt = {
        userID : userID,
        pin : pin
    };

    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    return await axios.post(`${baseURL}?type=3`, encrypted)
                    .then(response => response.data)
                    .catch(err => {console.log(err)});
}

async function resendOTP(userID) {
    var valueToEncrypt = {
        userID : userID
    };

    console.log(userID);

    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    return await axios.post(`${baseURL}?type=23`, encrypted)
                    .then(response => response.data)
                    .catch(err => {console.log(err)});
}

